import SidebarPortal from '@plone/volto/components/manage/Sidebar/SidebarPortal';
import { BlockDataForm } from '@plone/volto/components/manage/Form';
import { useIntl } from 'react-intl';
import schema from './schema';
import View from './View';
import BlockImageInput from '../../helpers/BlockImageInput/BlockImageInput';

const Edit = (props: any) => {
  const intl = useIntl();
  const {
    onChangeBlock,
    data,
    block,
    selected,
    navRoot,
    contentType,
    blocksErrors,
  } = props;
  const blockSchema = schema({ ...props, intl });

  const imageSlot = ({ fieldId, value, element }: any) => {
    if (fieldId !== 'image') return undefined;
    return (
      <BlockImageInput
        id="image"
        block={block}
        value={value}
        imageSize="great"
        onChange={(next) => onChangeBlock(block, { ...data, image: next })}
      >
        {element}
      </BlockImageInput>
    );
  };

  return (
    <>
      <View {...props} isEditMode imageSlot={imageSlot} />
      <SidebarPortal selected={selected}>
        <BlockDataForm
          schema={blockSchema}
          title={blockSchema.title}
          onChangeField={(id: string, value: any) => {
            onChangeBlock(block, { ...data, [id]: value });
          }}
          onChangeBlock={onChangeBlock}
          formData={data}
          block={block}
          navRoot={navRoot}
          contentType={contentType}
          errors={blocksErrors}
        />
      </SidebarPortal>
    </>
  );
};

export default Edit;
